import { all, fork } from 'redux-saga/effects';
import { adminEmailDeliveriesSaga } from '@/features/admin/store/admin-email-deliveries.saga';
import { adminStatsSaga } from '@/features/admin/store/admin-stats.saga';
import { staffAccessSaga } from '@/features/access/store/staff-access.saga';
import { staffSessionsSaga } from '@/features/access/store/staff-sessions.saga';
import { staffAccountsSaga } from '@/features/admin/store/staff-accounts.saga';
import { adminSaga } from '@/features/admin/store/admin.saga';
import { authSaga } from '@/features/auth/store/auth.saga';
import { claimsSaga } from '@/features/claims/store/claims.saga';
import { organizationsSaga } from '@/features/organizations/store/organizations.saga';
import { referralCodesSaga } from '@/features/referral-codes/store/referral-codes.saga';
import { salesInquiriesSaga } from '@/features/sales/store/sales-inquiries.saga';
import { storageSaga } from './storage.saga';

/** Özellik sagaları buraya bağlanır; her özellik kendi sagasını dışa verir. */
export function* rootSaga() {
  yield all([
    fork(storageSaga),
    fork(authSaga),
    fork(adminSaga),
    fork(adminStatsSaga),
    fork(adminEmailDeliveriesSaga),
    fork(claimsSaga),
    fork(staffAccessSaga),
    fork(staffAccountsSaga),
    fork(staffSessionsSaga),
    fork(salesInquiriesSaga),
    fork(organizationsSaga),
    fork(referralCodesSaga),
  ]);
}
